
import React from 'react';

const HeaderDetails = (p) => {

    //console.log(p)
    return (
        <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            //alignContent: 'space-between',
            justifyContent: 'space-evenly',
            margin: 'auto',
        }}>
            {p.children}
        </div>
    );
};

export default HeaderDetails;
